import { CheckCircle2, Lightbulb, Pencil } from "lucide-react";
import { L } from "@/i18n";

const LETTERS = "ABCDEFGH";

export const QuestionCard = ({ q, index, onEdit }) => (
  <article className="rounded-lg bg-[#131f37] border border-[#1e293b] p-5 hover:border-slate-700/80 transition-colors" data-testid={`question-card-${q.id}`}>
    <header className="flex flex-wrap items-center gap-2 mb-3 text-[11px] font-mono">
      <span className="text-slate-500">#{index}</span>
      <span className="rounded bg-amber-500/10 px-2 py-0.5 text-amber-400">{q.module_title}</span>
      {q.module_subtitle && <span className="text-slate-500 truncate">{q.module_subtitle}</span>}
      <span className="ml-auto flex items-center gap-2">
        {q.difficulty && <span className="rounded border border-slate-700 px-2 py-0.5 uppercase text-slate-400">{q.difficulty}</span>}
        <button
          type="button"
          onClick={() => onEdit(q)}
          className="flex items-center gap-1 rounded border border-slate-700 px-2 py-0.5 text-slate-300 hover:border-amber-500/60 hover:text-amber-400 transition-colors"
          data-testid={`question-edit-${q.id}`}
        >
          <Pencil className="h-3 w-3" /> {L("Edit", "Editar")}
        </button>
      </span>
    </header>
    <p className="text-sm text-slate-100 leading-relaxed" data-testid={`question-text-${q.id}`}>{q.question_text}</p>
    {q.question_image && <img src={q.question_image} alt={L("Question image", "Imagem da pergunta")} className="mt-3 max-h-64 rounded-md border border-slate-700" />}
    <ol className="mt-4 space-y-2">
      {q.options?.map((opt, i) => {
        const correct = i === q.correct_option;
        return (
          <li
            key={i}
            data-testid={`question-option-${q.id}-${i}`}
            data-correct={correct}
            className={`flex items-start gap-3 rounded-md border px-3 py-2 text-sm ${
              correct ? "border-emerald-500/40 bg-emerald-500/10 text-emerald-200" : "border-slate-800 bg-[#0f172a] text-slate-300"
            }`}
          >
            <span className={`font-mono text-xs mt-0.5 ${correct ? "text-emerald-400" : "text-slate-500"}`}>{LETTERS[i]}</span>
            <span className="flex-1">{opt}</span>
            {correct && <CheckCircle2 className="h-4 w-4 shrink-0 text-emerald-400 mt-0.5" />}
          </li>
        );
      })}
    </ol>
    <div className="mt-4 flex gap-2 rounded-md bg-[#0f172a] px-3 py-2.5 text-xs" data-testid={`question-explanation-${q.id}`}>
      <Lightbulb className="h-3.5 w-3.5 shrink-0 text-amber-500 mt-0.5" />
      {q.explanation ? <p className="text-slate-300 leading-relaxed">{q.explanation}</p> : <p className="text-slate-500 italic">{L("No explanation recorded.", "Sem explicação registada.")}</p>}
    </div>
  </article>
);
